module.exports = __webpack_public_path__ + "static/media/proxima-nova-regular.305945b5.woff2";